import {createFileRoute} from '@tanstack/react-router'
import {type} from 'arktype'

import stripDefaultSearchParams from '@/utils/router/middlewares/stripDefaultSearchParams'
import stripEmptySearchParams from '@/utils/router/middlewares/stripEmptySearchParams'
import stripZeroSearchParams from '@/utils/router/middlewares/stripZeroSearchParams'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_SEARCH_PARAMS = {
  step: 1,
  option: 0,
  applyRewards: false,
  coupon: '',
}

const flightDetailSchema = type({
  step: fallbackToDefault(type('0 <= number.integer <= 5'), DEFAULT_SEARCH_PARAMS.step),
  option: fallbackToDefault(type('number.integer >= 0'), DEFAULT_SEARCH_PARAMS.option),
  applyRewards: fallbackToDefault(type.boolean, DEFAULT_SEARCH_PARAMS.applyRewards),
  coupon: fallbackToDefault(searchParamString, DEFAULT_SEARCH_PARAMS.coupon),
})

export const Route = createFileRoute('/flights/$flightId/')({
  validateSearch: flightDetailSchema,
  search: {
    middlewares: [
      stripDefaultSearchParams(DEFAULT_SEARCH_PARAMS),
      stripZeroSearchParams(),
      stripEmptySearchParams(),
    ],
  },
})
